module.exports = __webpack_public_path__ + "img/root101.45469688.png";